<div class="navbar navbar-expand-md flex-md-column">
  <div class="container-fluid app-navbar">
    <div class="btn-group" dropdown [isAnimated]="true" [autoClose]="true">
      <button
        class="navbar-btn dropdown-toggle navbar-toggler"
        type="button"
        [attr.aria-expanded]="!isNavbarCollapsed"
        dropdownToggle
        type="button"
        aria-controls="dropdown-basic"
        aria-label="Toggle navigation"
      >
        <i class="fa fa-bars text-white"></i>
      </button>
      <div
        id="dropdown-basic"
        style="width: 240px"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        aria-labelledby="button-basic"
      >
        <dx-tree-view
          [items]="navBarItems"
          displayExpr="name"
          [selectByClick]="false"
          [width]="'260px'"
          [height]="'320px'"
          [rtlEnabled]="true"
          [showExpandAll]="false"
          [showFirstSubmenuMode]="'onClick'"
          (onItemClick)="navItemClick($event)"
        ></dx-tree-view>
      </div>
    </div>

    <div class="logo-container d-md-flex ms-md-5 mx-auto ps-5">
      <div class="col-lg-auto text-center me-2">
        <img
          src="/assets/images/afra-school.svg"
          alt="لوگوی افرا"
          style="height: 32px"
        />
      </div>
      <div class="col-lg-auto d-flex align-items-center text-center">
        <h6 class="text-white clickable m-0 mt-2" [routerLink]="'/'">
          {{ systemNameLabel }}
        </h6>
      </div>
    </div>
    <div class="btn-group" dropdown [isAnimated]="true" [insideClick]="true">
      <button
        class="dropdown-toggle navbar-btn border-0 bg-transparent position-relative"
        type="button"
        dropdownToggle
        aria-controls="dropdown-basic"
        aria-label="Toggle navigation"
      >
        <i class="fa fa-bell text-white fs-4"></i>
        <span
          class="m-2 bg-danger d-block position-absolute top-0 end-0"
          style="width: 6px; height: 6px; border-radius: 50%"
          *ngIf="unseenNotifCount + unseenMessageCount > 0"
        ></span>
      </button>
      <div
        id="dropdown-basic"
        style="width: 270px"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="button-basic"
      >
        <app-notificatoins-and-messages-dropdown
          [notifications]="notificationsResponse"
          [messages]="messagesResponse"
        ></app-notificatoins-and-messages-dropdown>
      </div>
    </div>
    <div class="text-center text-lg-end my-2 me-md-5">
      <app-auth-bar></app-auth-bar>
    </div>
  </div>
  <div class="w-100 bg-success-subtle bg-gradient">
    <ul class="navbar-nav flex-row gap-3 mr-auto d-none d-md-flex">
      <ng-container *ngFor="let item of navBarItems">
        <li class="nav-item dropdown" *ngIf="item.items" dropdown>
          <a
            class="nav-link dropdown-toggle"
            id="navbarDropdown"
            [attr.aria-expanded]="false"
            aria-haspopup="true"
            data-bs-toggle="dropdown"
            data-toggle="dropdown"
            role="button"
            dropdownToggle
          >
            {{ item.name }}
            <span
              class="fa fa-caret-left"
              style="transform: rotate(-90deg)"
            ></span>
          </a>
          <div
            *dropdownMenu
            aria-labelledby="navbarDropdown"
            class="dropdown-menu dropdown-menu-right"
            role="menu"
          >
            <ng-container *ngFor="let subItem of item.items">
              <li class="dropdown-item">
                <a class="nav-link" [routerLink]="subItem.urlParts.join('/')">
                  {{ subItem.name }}
                </a>
              </li>
            </ng-container>
          </div>
        </li>
        <li class="nav-item" *ngIf="!item.items">
          <a
            class="nav-link"
            [routerLink]="item.urlParts.join('/')"
            [routerLinkActive]="'active'"
          >
            {{ item.name }}
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
<!-- #7cde7c -->
